import {
  TuiHint,
  TuiInput,
  tuiItemsHandlersProvider,
  TuiIcon,
  TuiDropdown,
  TuiTextfield,
  TuiLabel,
} from '@taiga-ui/core';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  TuiDataListWrapper,
  TuiSelect,
  TuiTooltip,
  TuiChevron,
} from '@taiga-ui/kit';
import {
  FieldOptionValue,
  WorkflowFormFieldInputSelect,
} from '@features/requests/request-form/components/request-form-workflows/types';

@Component({
  selector: 'x-input-select-field',
  imports: [
    TuiTextfield,
    TuiLabel,
    TuiChevron,
    ReactiveFormsModule,
    TuiSelect,
    TuiDataListWrapper,
    TuiHint,
    TuiInput,
    TuiIcon,
    TuiTooltip,
    TuiDropdown,
  ],
  templateUrl: './input-select-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
  providers: [
    tuiItemsHandlersProvider({
      stringify: signal((item: FieldOptionValue) => item.title),
    }),
  ],
})
export class InputSelectFieldComponent {
  field = input.required<WorkflowFormFieldInputSelect>();
  control = input.required<FormControl<string | null>>();

  stringifyItems = (item: string) => item;
}
